'use client'

import { useLayoutEffect } from 'react'
import { syncNotebookRouteDom } from './notebook-route-activation'

/**
 * Runs DOM hygiene after shell content is ready (dedupe ghost slots / route mounts).
 * Does not change layout metrics — only removes duplicate Activity subtrees.
 */
export function useNotebookRouteDomSync(enabled, deps = []) {
  useLayoutEffect(() => {
    if (!enabled) return undefined

    syncNotebookRouteDom()
    const raf1 = requestAnimationFrame(() => {
      syncNotebookRouteDom()
      requestAnimationFrame(() => syncNotebookRouteDom())
    })

    return () => cancelAnimationFrame(raf1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, ...deps])
}
